import VueApollo from "vue-apollo";
import Vue from "vue";
import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
  // concat,
} from "@apollo/client/core";
import { onError } from "@apollo/client/link/error";

Vue.use(VueApollo);

const httpLink = new HttpLink({
  uri: "https://wecan-art.hasura.app/v1/graphql",
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      ...(localStorage.getItem("token") && {
        authorization: "Bearer " + localStorage.getItem("token"),
      }),
    },
  }));

  return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([errorLink, authMiddleware, httpLink]), //concat(authMiddleware, httpLink),
});

export default new VueApollo({
  defaultClient: apolloClient,
});
